if (!customElements.get("lsg-sub-membership-info")) {
  customElements.define("lsg-sub-membership-info", class LSGSubMembershipInfo extends HTMLElement {
    constructor() {

      super();
      this.selectors = {
        toggle: ".js-lsg-sub-membership-info-toggle"
      };
      this.toggle = this.querySelector(this.selectors.toggle);
      if (this.toggle != null) {
        this.init();
      }
    }

    init() {
      this.toggle.addEventListener('click',()=>{
        this.classList.toggle('is-open')
      })
    }
  })
}
